import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RouterLinkFactory {
  homepage(): string[] {
    return ['/dashboard'];
  }

  profile(): string[] {
    return ['/dashboard/profile'];
  }

  employees(): string[] {
    return ['/dashboard/employees'];
  }

  addEmployee(): string[] {
    return ['add'];
  }

  editEmployee(id: string): string[] {
    return ['edit', id];
  }

  branches(): string[] {
    return ['/dashboard/branches'];
  }

  addBranch(): string[] {
    return ['add'];
  }

  editBranch(id: string): string[] {
    return ['edit', id];
  }

  invoices(): string[] {
    return ['/dashboard/invoices'];
  }

  invoiceDetails(id: string): string[] {
    return ['/dashboard/invoices', 'details', id];
  }

  externalInvoiceDetails(id: string): string[] {
    return ['/dashboard/invoices', 'external', 'details', id];
  }

  paymentDetails(id: string): string[] {
    return ['/dashboard/invoices', 'payments', 'details', id];
  }

  auditHistory(): string[] {
    return ['/dashboard/audit-history'];
  }

  reports(): string[] {
    return ['/dashboard/reports'];
  }
}
